import firebase from "firebase/app";
import * as api from "../../api/api";
import { mutationTypes } from "./enums/mutation-types";
import {
  subscribeToRoomChanges,
  unsubscribeToRoomChanges,
} from "../../api/listeners";
import "firebase/auth";
import { NoRoomId } from "./errors/NoRoomIdError";

const actions = {
  signInAndGetRoom({ dispatch, commit }, roomId) {
    firebase.auth().onAuthStateChanged(async (user) => {
      commit(mutationTypes.SET_TOKEN, await user.getIdToken(true));
      dispatch("getRoom", roomId);
    });
    firebase
      .auth()
      .signInAnonymously()
      .catch((error) => commit(mutationTypes.FAILURE, error));
  },
  callTechnician({ commit }, roomId) {
    commit("loading");
    api
      .createCall(roomId, false)
      .then(() => commit(mutationTypes.CALL_SUCCESS))
      .catch((error) => commit(mutationTypes.FAILURE, error));
  },
  callTechnicianWithInformation({ commit }, data) {
    commit("loading");
    api
      .createCallWithInformations(data.roomId, false, data.user)
      .then(() => commit(mutationTypes.CALL_SUCCESS))
      .catch((error) => commit(mutationTypes.FAILURE, error));
  },
  confirmIntervention({ commit, dispatch }, roomId) {
    commit("loading");
    dispatch("unsubscribeToRoom", roomId);
    return api
      .createCall(roomId, true)
      .then(() => commit(mutationTypes.CALL_SUCCESS))
      .catch((error) => {
        dispatch("subscribeToRoom", roomId);
        commit(mutationTypes.FAILURE, error);
      });
  },
  getRoom({ commit, state }, roomId) {
    commit("loading");
    api
      .getRoom(roomId, state.token)
      .then((json) => commit(mutationTypes.ROOM_SUCCESS, json))
      .catch((error) => commit(mutationTypes.FAILURE, error));
  },
  subscribeToRoom({ commit }, roomId) {
    subscribeToRoomChanges(roomId, (value) =>
      commit(mutationTypes.UPDATE_ROOM_STATUS, value.status)
    );
  },
  unsubscribeToRoom(context, roomId) {
    unsubscribeToRoomChanges(roomId);
  },
  resetStage({ commit }) {
    commit(mutationTypes.UPDATE_ROOM_STATUS, "INACTIVE");
  },
  triggerError({ commit }) {
    commit(mutationTypes.FAILURE, new NoRoomId());
  },
};

export { actions };
